import { render } from "./Adjustment.vue?vue&type=template&id=7fd42de1"
import script from "./Adjustment.vue?vue&type=script&lang=js"
export * from "./Adjustment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__